import React from 'react';
import styled from 'styled-components';

import {
  VerticalMenuClickableItem,
  VerticalMenuNavItem,
  VerticalSubmenuLinkItem,
} from 'components/basic/Button/verticalMenu';
import MaterialSymbol from 'components/basic/icons/MaterialSymbol';
import { socialLinksIconsList } from 'components/layout/footer/socialLinksList';
import { resourcesLinks } from 'components/layout/header/resourcesLinks';
import WalletHeader from 'components/wallet/dashboard/header/WalletHeader';
import { APP_VERSION } from 'config/constants';
import useRedirectNonMobile from 'hooks/useRedirectNonMobile';
import { formatUsdWithSign } from 'lib/display/formatting';
import { useSelector } from 'reduxState/store';
import { scrollbarStyle } from 'styleShared';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const ScrollableContent = styled.div`
  overflow-y: auto;
  ${scrollbarStyle}
`;

const Divider = styled.div`
  background: var(--separator);
  height: 1px;
  margin: 16px 0;
`;

const Stats = styled.div`
  margin: 12px 15px 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

const MenuWrap = styled.div`
  margin: 16px 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const Label = styled.div`
  font-size: var(--small);
  line-height: 1.5;
  white-space: nowrap;
  color: var(--gray4b);
`;

const Value = styled.div`
  font-size: var(--medium2);
  line-height: 1.5;
  color: var(--white);
  word-wrap: break-word;
  overflow: hidden;
`;

const ValueVersion = styled(Value)`
  color: var(--gray4);
  font-size: var(--medium);
`;

/**
 * Note that actions can be very similar to desktop ProfileMenuBox.tsx
 */
export default function MorePageMobile() {
  useRedirectNonMobile('/');
  const volume24hUsd = useSelector(
    state => state.exchange.infoStats.katanaChainVolume24hUsd
  );

  return (
    <Wrap>
      <WalletHeader title="More" showBalanceActions noBack />

      <ScrollableContent>
        <Stats>
          <div>
            <Label>24h Volume</Label>{' '}
            <Value>{formatUsdWithSign(volume24hUsd, { decimals: 0 })}</Value>
          </div>
          <div>
            <Label>App Version</Label>
            <ValueVersion>{APP_VERSION}</ValueVersion>
          </div>
        </Stats>

        <Divider />

        <MenuWrap>
          <VerticalMenuNavItem
            icon={<MaterialSymbol icon="list_alt" fontSize="inherit" />}
            to="/markets"
          >
            Markets
          </VerticalMenuNavItem>

          <VerticalMenuClickableItem
            icon={<MaterialSymbol icon="help" fontSize="inherit" />}
          >
            Social
          </VerticalMenuClickableItem>

          {socialLinksIconsList.map(({ name, link }) => (
            <VerticalSubmenuLinkItem key={link} href={link}>
              {name}
            </VerticalSubmenuLinkItem>
          ))}

          <VerticalMenuClickableItem
            icon={<MaterialSymbol icon="help" fontSize="inherit" />}
          >
            Resources
          </VerticalMenuClickableItem>

          {resourcesLinks.map(resource => (
            <VerticalSubmenuLinkItem key={resource.label} href={resource.to}>
              {resource.label}
            </VerticalSubmenuLinkItem>
          ))}

          <VerticalMenuNavItem
            icon={<MaterialSymbol icon="settings" fontSize="inherit" />}
            to="/mobile-more/settings"
          >
            Settings
          </VerticalMenuNavItem>
        </MenuWrap>
      </ScrollableContent>
    </Wrap>
  );
}
